var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("polyline", {
        staticClass: "chart-line",
        attrs: {
          points: "3,16 10,8.5 15,14 21,8",
          stroke: _vm.color,
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }),
      _c("circle", {
        staticClass: "chart-node",
        attrs: { cx: "3", cy: "16", r: "1.7", fill: _vm.color }
      }),
      _c("circle", {
        staticClass: "chart-node",
        attrs: { cx: "10", cy: "8.5", r: "1.7", fill: _vm.color }
      }),
      _c("circle", {
        staticClass: "chart-node",
        attrs: { cx: "15", cy: "14", r: "1.7", fill: _vm.color }
      }),
      _c("circle", {
        staticClass: "chart-node",
        attrs: { cx: "21", cy: "8", r: "1.7", fill: _vm.color }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }